import styled from 'styled-components'

export const ContentUnavailableWrapper = styled.div`
  height: 830px;
  margin-right: 112px;
`

export const PageContentLoaderWrapper = styled.div`
  position: relative;
  width: 1585px;
  height: 90%;
`
